var prevStartup = __webpack_require__.x;
var hasRun = false;
__webpack_require__.x = () => {
	if (!hasRun) {
	  hasRun = true;
	  __webpack_require__(/*! ./node_modules/.pnpm/@angular-devkit+build-angular@21.2.22_4d59e1dd15e8b526137b508d23a5ca31/node_modules/@angular-devkit/build-angular/src/tools/babel/webpack-loader.js??ruleSet[1].rules[2].use[0]!./node_modules/.pnpm/@ngtools+webpack@21.2.22_@angular+compiler-cli@21.2.21_@angular+compiler@21.2.21_typesc_e821fd9c424263564b651f7d750b9df5/node_modules/@ngtools/webpack/src/ivy/index.js!./node_modules/.pnpm/source-map-loader@5.0.0_webpack@5.105.2_@swc+core@1.16.1_@swc+helpers@0.5.23__esbuild@0.28.1_postcss@8.5.23_/node_modules/source-map-loader/dist/cjs.js??ruleSet[1].rules[3]!./node_modules/.federation/entry.ff4034c97fbcfb57908bcf4264a5f997.js */ 8400);
	}
	if (typeof prevStartup === 'function') {
	  return prevStartup();
	} else {
	  console.warn('[Module Federation] prevStartup is not a function, skipping startup execution');
	}
};